import { $ } from './../../helpers/query'
import {SectionAnimationTemplate} from './SectionAnimationTemplate'

export class FeaturesAnimation extends SectionAnimationTemplate {
  constructor() {
    super();
    this.featuresSection = document.querySelector('#features-section');
    this.featuresCont = this.featuresSection.querySelector('.features__outer-container');
    this.featuresIntro = this.featuresSection.querySelector('.features__intro');
    this.featuresCarousel = this.featuresSection.querySelector('.features__carousel');
  }

  // 1. Interract whith Previous section
  // -- 1.1. Interract forward
  onVisitDown() {
    this.hideVideo()
    this.featuresSection.classList.add('animate__translate-up')
    this.featuresCarousel.classList.remove('features__carousel--start')
    setTimeout(() => {
      this.featuresIntro.classList.remove('features__intro--start')
    }, this.ANIM_DUR * 4/5)
    setTimeout(() => {
      this.featuresSection.classList.remove('animate__translate-up')
    }, this.ANIM_DUR + this.EXTRA_DUR)
  }

  // -- 1.2. Interract back
  onLeaveUp() {
    this.featuresCont.classList.add('animate__translate-down')
    setTimeout(() => {
      this.featuresIntro.classList.add('features__intro--start')
      this.featuresCarousel.classList.add('features__carousel--start')
      this.featuresCont.classList.remove('animate__translate-down')
    }, this.ANIM_DUR + this.EXTRA_DUR)
  }

  // 2. Interract whith Next section
  // -- 2.1. Interract forward
  onLeaveDown() {
    this.featuresCont.classList.add('animate__translate-up')
    this.featuresCont.classList.add('invisible')
    setTimeout(() => {
      this.featuresIntro.classList.add('features__intro--start')
      this.featuresCarousel.classList.add('features__carousel--start')
      this.featuresCont.classList.remove('animate__translate-up')
    }, this.ANIM_DUR + this.EXTRA_DUR)
  }

  // -- 2.2. Interract back
  onVisitUp() {
    this.hideVideo()
    this.featuresCont.classList.add('animate__translate-down')
    this.featuresCont.classList.remove('invisible')
    this.featuresIntro.classList.remove('features__intro--start')
    this.featuresCarousel.classList.remove('features__carousel--start')
    setTimeout(() => {
      this.featuresCont.classList.remove('animate__translate-down')
    }, this.ANIM_DUR + this.EXTRA_DUR)
  }
}
